'use strict';
import {gsap} from 'gsap';
import 'jquery-mousewheel';
import 'jquery-touchswipe';
import 'jquery.scrollto';

var _this;

class anchorTool {

    constructor(anchorComponent) {

        _this = this;
        this.container = anchorComponent;
        this.active = false;

        /**
         * Attach Mouse Wheel inidicator
         */
        this.totalMove = 0;
        this.wheeldelta = {
            y: 0,
        };
        this.wheeling;

        //_this.attachScrollDetectMouse();
        //_this.attachSwipeDetect();
        _this.attachWindowScroll();
        _this.attachClickAnchorTool();
        _this.attachStickyScrollClass();

        // TOOL
        $('#anchor-tool-mobile').click(function () {
            $('#anchor-nav ul').slideToggle();
            $(this).toggleClass('open');
        });


    }

    attachWindowScroll() {

        let arrElemAnchorTool = _this.container.find('ul li a');

        //console.log(arrElemAnchorTool[0]);

        $(window).scroll(function () {

            // console.log('scroll');
            let scrollToTop = $(window).scrollTop();
            console.log('SCROLL TO TOP', scrollToTop);

            if (scrollToTop > 40 && _this.container.length > 0 && !_this.active) {
                // console.log('sposto');
                let heightHeader = $('header').height() - 1;
                gsap.to(_this.container, 0.5, {top: heightHeader});
                _this.active = true;


            } else if (scrollToTop < 40) {
                gsap.to(_this.container, 0.5, {top: '-300px'});
                _this.active = false;
                // _this.container.find('li.active').removeClass('active');
            }

            for (let i = 0; i < arrElemAnchorTool.length; i++) {

                let anchorToolItem = $(arrElemAnchorTool[i]);
                let idElem = anchorToolItem.attr('data-id-anchor');
                //console.log(idElem);
                let elemBox = $('#' + idElem);
                //let offsetTopElemBoxAnchor =  elemBox.offset().top;
                //console.log('offsetTopElemBoxAnchor' , idElem, offsetTopElemBoxAnchor);
                let positionTopElemBoxAnchor = elemBox.position().top;

                //console.log('diff ', idElem, positionTopElemBoxAnchor - scrollToTop);

                //let elemBoxH = elemBox.height() + parseInt(elemBox.css('padding-top')) + parseInt(elemBox.css('padding-bottom')) + parseInt(_this.container.css('padding-bottom'));
                let elemBoxH = elemBox.height();

                let diff = 250;

                let diffBoxPosScroll = positionTopElemBoxAnchor - scrollToTop;
                if (diffBoxPosScroll <= diff && diffBoxPosScroll > 0) {
                    _this.container.find('li.active').removeClass('active');
                    anchorToolItem.parents('li').addClass('active');
                    let labelIdToScroll = $('a[data-id-anchor=\'' + idElem + '\']').attr('data-label');
                    $('#anchor-tool-mobile').html(labelIdToScroll.replace('<br>', ' '));
                } else if ((scrollToTop + diff) > (positionTopElemBoxAnchor + elemBoxH)) {
                    // anchorToolItem.parents('li').removeClass('active');
                    // _this.container.find('li.active').removeClass('active');
                    let labelIdToScroll = $('a[data-id-anchor=\'' + idElem + '\']').attr('data-label');
                    $('#anchor-tool-mobile').html(labelIdToScroll.replace('<br>', ' '));
                }
                //console.log(positionTopElemBoxAnchor , elemBox.height(), positionTopElemBoxAnchor + elemBox.height(), scrollToTop)
            }


        });

        $(window).resize(function () {

            _this.active = false;

        });

    }

    attachStickyScrollClass() {

        $(document).on('scroll', function () {
            check_stickies();
        })

        function check_stickies() {
            if (_this.container.css('position') == 'sticky') {
                let currentOffset = _this.container.get(0).getBoundingClientRect().top;
                // console.log(currentOffset);
                let stickyOffset = parseInt(_this.container.css('top').replace('px', '')) + 20;
                let isStuck = currentOffset <= stickyOffset;
                // console.log('CURRENT: ' + currentOffset);
                // console.log('STICKYOFFSET: ' + stickyOffset);
                if (isStuck) {
                    _this.container.addClass('is-sticky');
                } else {
                    _this.container.removeClass('is-sticky');
                }
            }
        }

    }

    attachClickAnchorTool() {

        _this.container.find('a').click(function (event) {

            event.preventDefault();
            let idAnchor = $(this).attr('data-id-anchor');

            _this.scrollToBox(idAnchor);

            if ($(window).width() < 992) {
                $(this).parents('ul').slideToggle();
                $(this).parents('.anchorTool').find('#anchor-tool-mobile').toggleClass('open');
            }

            //let offsetToScroll = $('#'+idAnchor).offset().top - $('header.site-header').height() - _this.container.height();
            //$('body').scrollTo(offsetToScroll,500);
        });

    }

    scrollToBox(idToScroll) {
        // $( 'a[data-id-anchor!=\'\']' ).parents('li').removeClass('active');
        // $( 'a[data-id-anchor=\''+idToScroll+'\']' ).parents('li').addClass('active');
        // let labelIdToScroll = $( 'a[data-id-anchor=\''+idToScroll+'\']' ).attr('data-label');
        // $('.tool-anchor-indicator-mobile').html(labelIdToScroll.replace('<br>',' '));

        let elmToScroll = jQuery('#' + idToScroll);

        // console.log(elmToScroll);

        let elmMarginBottom = 10;

        // if(!elmToScroll.hasClass('site-block')) {
        // 	elmPaddingTop = parseInt(elmToScroll.parent().parent().parent().css('padding-top'));
        // }
        // let elemPrev = elmToScroll.prev();
        // if (elemPrev.hasClass('anchorTool')) {
        // 	elemPrev = elemPrev.prev();
        // }
        // elmMarginBottom = parseInt(elmToScroll.prev().css('margin-bottom'));
        // console.log(elmMarginBottom);
        let elmGetH = jQuery('#anchor-nav > #anchor-tool-mobile', _this.container);

        let containerHeight = 0;
        if (elmGetH.length) {
            containerHeight = elmGetH.height() + parseInt(elmGetH.css('padding-top')) + parseInt(elmGetH.css('padding-bottom')) + parseInt(_this.container.css('padding-bottom'));
        }
        console.log(containerHeight);
        jQuery(window).scrollTo(elmToScroll, {
            duration: 500,
            offset: {
                top: -(jQuery('header').height() + containerHeight + elmMarginBottom),
            },
        });
    }

    attachScrollDetectMouse() {

        //$('body').mousewheel(function(event) {
        $('body').mousewheel(function () {

            clearTimeout(_this.wheeling);
            _this.wheeling = setTimeout(function () {
                // console.log('stop wheeling!');
                _this.wheeling = false;
                //_this.TLMove.reverse();
                _this.currMove = 0;
                _this.wheeling = undefined;


                // reset wheeldelta
                _this.wheeldelta.y = 0;
            }, 250);

            _this.wheeling = true;

            /*let offsetScrollY = event.deltaY*event.deltaFactor;

             _this.totalMove += offsetScrollY;
             if(_this.totalMove >= 0)
             _this.totalMove = 0;*/


            let scrollToTop = $(window).scrollTop();

            //console.log('DELTA Y: ',event.deltaY);
            //console.log('DELTA FACTOR: ',event.deltaFactor);
            //console.log('TOTAL MOVE',_this.totalMove);
            console.log('SCROLL TO TOP', scrollToTop);


        });

    }

    attachSwipeDetect() {

        $('body').swipe({
            swipe: function (event, direction) {
                console.log('DIRECTION SWIPE : ', direction);
                console.log('EVENT SWIPE : ', event);


                let scrollToTop = $(window).scrollTop();

                console.log('BODY SCROLL : ', scrollToTop);

                //console.log("ELEM HOVER",_this.currElemOnHover);

                /*
                 if(_this.verticalOnMobile && windowWidth <= _this.limitMobileWidth){
                 return;
                 }
                 if(windowWidth <= _this.limitMobileWidth){
                 //console.log("SWIPE SINGLE swipe direction : " + currentDirection, "Distance from inital touch: " + distance, "Duration of swipe: " + duration + " Current direction: " + currentDirection );

                 if(direction == "left") {

                 let sectionSwipeToLeftForce = $(_this.slideNavigation.get(window.indexCurrentActiveElementSliderNavigation)).attr("data-swipe-left-to");
                 if(sectionSwipeToLeftForce != undefined)
                 _this.goToSection(sectionSwipeToLeftForce);
                 else
                 _this.goToNextSection();
                 }

                 if(direction == "right") {

                 let sectionSwipeToRightForce = $(_this.slideNavigation.get(window.indexCurrentActiveElementSliderNavigation)).attr("data-swipe-right-to");
                 if(sectionSwipeToRightForce != undefined)
                 _this.goToSection(sectionSwipeToRightForce);
                 else
                 _this.goToPrevSection();
                 }

                 //_this.move(distance,currentDirection);
                 }*/

            },
            threshold: 10,
            maxTimeThreshold: 5000,
            fingers: 'all',
        });
    }


}

export default anchorTool


// WEBPACK FOOTER //
// ./scripts/components/anchorTool.js